var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/System/Arrows/Collapse"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5.488330, 7.511670)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25,-1.75 C6.44526215,-1.94526215 6.76184464,-1.94526215 6.95710678,-1.75 C7.13067313,-1.57643365 7.14995828,-1.30700925 7.01496223,-1.11214111 L6.95710678,-1.04289322 L3.31055339,2.60355339 L6.95710678,6.25 C7.13067313,6.42356635 7.14995828,6.69299075 7.01496223,6.88785889 L6.95710678,6.95710678 C6.78354043,7.13067313 6.51411603,7.14995828 6.31924789,7.01496223 L6.25,6.95710678 L1.89644661,2.60355339 L6.25,-1.75 Z",
    id: "Path-3",
    transform: "translate(4.500000, 2.603553) scale(-1, 1) rotate(-270.000000) translate(-4.500000, -2.603553) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.317218db6ecfbf9e957f1c6b7c46c79a.svg";
export { ForwardRef as ReactComponent };